module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    attrs: {
      "icon": "facebook",
      "state": _vm.readyForCAP,
      "badge": "badge"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('campaign_field.title.facebook-page')))]), _c('template', {
    slot: "content"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "value": _vm.pageUrl,
      "readonly": ""
    }
  }), (!_vm.readonly) ? _c('b-input-group-button', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('b-btn', {
    attrs: {
      "variant": "box"
    },
    on: {
      "click": _vm.showModal
    }
  }, [(!_vm.hasPage) ? [_vm._v(_vm._s(_vm.$t('terms.misc.connect-fb-page')))] : (_vm.claimed) ? [_vm._v(_vm._s(_vm.$t('terms.misc.change')))] : [_vm._v(_vm._s(_vm.$t('terms.misc.change-or-connect')))]], 2)], 1) : _vm._e()], 1)], 1)], 2), _c('b-modal', {
    ref: "modal",
    attrs: {
      "size": "lg",
      "hide-footer": true,
      "title": _vm.$t("pos.campaign.connect-your-campaign-to-facebook")
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.showClaimMessage) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.claim-is-sent-and-waiting')))]) : _vm._e(), (_vm.showClaimSuccess) ? _c('b-alert', {
    attrs: {
      "show": "show",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.claim-is-approved')))]) : _vm._e(), (_vm.showInvitation) ? _c('b-btn', {
    attrs: {
      "variant": "link",
      "href": _vm.claimLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.accept-inviation-here')))]) : _vm._e()], 1), (!_vm.showInvitation) ? [_c('div', {
    staticClass: "input-container"
  }, [_c('v-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "placeholder": _vm.$t("campaign_field.placeholder.facebook-page"),
      "min-len": 2,
      "wait": 300,
      "items": _vm.items,
      "component-item": _vm.itemTemplate,
      "auto-select-one-item": false,
      "get-label": _vm.getLabel,
      "input-class": "form-control"
    },
    on: {
      "update-items": _vm.onUpdateItems
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), (_vm.selected) ? _c('label', {
    staticClass: "control-label",
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1) : _vm._e()], 1)] : _vm._e(), _c('div', {
    staticClass: "row mt-5 mb-3 text-center"
  }, [(_vm.showCancel) ? _c('div', {
    staticClass: "col-6"
  }, [_c('gotu-nav-button', {
    on: {
      "click": function($event) {
        _vm.forceCancel = !_vm.forceCancel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1) : _vm._e(), _c('div', {
    class: {
      "col-6": _vm.showCancel, "col-12": !_vm.showCancel
    }
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.disableConnect,
      "loading": _vm.claimsInProgress > 0
    },
    on: {
      "click": _vm.onConnect
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('terms.misc.connect')))])])], 1)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d70e835"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facebook-page-box/FacebookPageBox.vue
// module id = 2027
// module chunks = 1